import { useState } from 'react'
import '../styles/AddWeightButton.css'

const Modal = ({ setIsUsingModal, onSubmitAction, weightUnit, title, weightData }) => {
  const [weight, setWeight] = useState(weightData ? weightData.weight.toFixed(1) : 0)

  const onSubmit = () => {
    weightData ? onSubmitAction(weight, weightData.date) : onSubmitAction(weight);
    setIsUsingModal(false)
  }

  const onCancel = () => {
    setIsUsingModal(false)
  }

  return (
    <div className='modalContainer'> 
      <div className='modalDialog'>
        <div className='modalDialogTitle'>{title}</div>
        <form onSubmit={onSubmit}>
          <div className='formInput'>
            <label>Weight</label>
            <input className='modalWeightInput' type="number" placeholder={weightUnit} step={0.1} onChange={(e) => setWeight(e.target.valueAsNumber)} value={weight || ''}/>
          </div>
          <div className='formButtons'>
            <input type="submit" value='Confirm' className='formButton submitButton' onSubmit={onSubmit}/>
            <input type="button" value='Cancel' className='formButton cancelButton' onClick={onCancel}/>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Modal